import { useLang } from "@/i18n";

const SERVICES = [
  { id: "airport", image: "https://images.pexels.com/photos/15774577/pexels-photo-15774577.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", alt: "Chauffeur accueillant un passager" },
  { id: "business", image: "https://images.pexels.com/photos/8052221/pexels-photo-8052221.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940", alt: "Cliente d'affaires en voiture" },
  { id: "longdistance", image: "https://images.pexels.com/photos/15071551/pexels-photo-15071551.jpeg?auto=compress&cs=tinysrgb&w=940", alt: "Berline noire au crépuscule, lumières de la ville" },
];

export default function Services({ onBook }) {
  const { t } = useLang();
  return (
    <section id="prestations" className="py-24 px-6 border-b border-[#212631]" data-testid="services-section">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-4">
          <div>
            <span className="font-mono text-xs uppercase tracking-[0.25em] text-[#c9a24d] block mb-2">{t("svc.kicker")}</span>
            <h2 className="font-disp text-3xl md:text-5xl text-white">{t("svc.title")}</h2>
          </div>
          <p className="text-sm text-[#9ea8b6] max-w-sm">{t("svc.sub")}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((s) => (
            <div key={s.id} data-testid={`service-card-${s.id}`}
              className="bg-[#0d1017] border border-[#212631] hover:border-[#c9a24d]/60 rounded-2xl p-6 flex flex-col justify-between group transition-all duration-300 shadow-xl">
              <div>
                <div className="h-48 rounded-xl mb-6 overflow-hidden relative border border-[#212631]">
                  <img src={s.image} alt={s.alt} loading="lazy"
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#060709]/70 via-transparent to-transparent"></div>
                  <div className="absolute top-3 right-3 rtl:right-auto rtl:left-3 font-mono text-[10px] bg-[#060709]/90 text-[#c9a24d] px-2.5 py-1 rounded-md border border-[#c9a24d]/30">{t(`s.${s.id}.tag`)}</div>
                </div>
                <h3 className="font-disp text-2xl text-white mb-2">{t(`s.${s.id}.title`)}</h3>
                <p className="text-sm text-[#8c98a9] mb-4">{t(`s.${s.id}.desc`)}</p>
              </div>
              <div className="pt-4 border-t border-[#212631] flex items-center justify-between">
                <span className="font-mono text-xs text-[#8c98a9]">{t(`s.${s.id}.foot`)}</span>
                <button onClick={onBook} data-testid={`service-book-${s.id}`}
                  className="font-geom text-xs font-bold text-[#c9a24d] group-hover:translate-x-1 rtl:group-hover:-translate-x-1 transition-transform inline-flex items-center gap-1">
                  {t("svc.book")}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
